export default __webpack_public_path__ + "static/media/category4.398b78c0.png";